import PropTypes from "prop-types";

import { Box, Grid, Typography } from "@mui/material";
import { getEligibleEmployees, getIneligibleEmployees, getEmployeeUnrankedCount } from "../../util/bid/bidGroupUtils";
import { getStandardEmployeesCount, getReliefEmployeesCount } from "../../util/bid/freedayBidUtils";

const FreedayBidGroupCounters = (props) => {
  const renderBidGroupCounts = () => {
    return (
      <Box sx={{ padding: "5px" }}>
        <Grid container>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  Eligible
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                Total:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getEligibleEmployees(props.bidGroup).length}
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                Standard:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getStandardEmployeesCount(getEligibleEmployees(props.bidGroup))}
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                Relief:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getReliefEmployeesCount(getEligibleEmployees(props.bidGroup))}
                </Typography>
              </Grid>
              <Grid item xs={3} sx={{ textAlign: "left" }}>
                Unranked:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getEmployeeUnrankedCount(getEligibleEmployees(props.bidGroup))}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  Ineligible
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                Total:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getIneligibleEmployees(props.bidGroup).length}
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                Standard:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getStandardEmployeesCount(getIneligibleEmployees(props.bidGroup))}
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "left" }}>
                Relief:{" "}
                <Typography component="span" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  {getReliefEmployeesCount(getIneligibleEmployees(props.bidGroup))}
                </Typography>
              </Grid>
              <Grid item xs={3}></Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  };

  return <div>{renderBidGroupCounts()}</div>;
};

FreedayBidGroupCounters.propTypes = {
  bid: PropTypes.object.isRequired,
  bidGroup: PropTypes.array.isRequired,
};

export default FreedayBidGroupCounters;
